import { latinizeReplace } from '../services/language/latinize';

export const stripAndClean = (str: string): string =>
  str
    .toLowerCase()
    .replace(/[^A-Za-z\d[\] ]/g, latinizeReplace)
    .replace(/ /g, '');
